import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import getPalette from './palette';
import typography from './typography';
import componentsOverride from './overrides';
import { getShadows, getCustomShadows } from './shadows';

// ----------------------------------------------------------------------

ThemeProvider.propTypes = {
  children: PropTypes.node,
  mode: PropTypes.oneOf(['light', 'dark']),
};

export default function ThemeProvider({ children, mode = 'light' }) {
  const themeOptions = useMemo(
    () => {
      const activePalette = getPalette(mode);
      return {
        palette: activePalette,
        shape: { borderRadius: 8 },
        typography,
        shadows: getShadows(activePalette),
        customShadows: getCustomShadows(activePalette),
      };
    },
    [mode]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
